<template>
  <div class="course_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      ref="table"
      pagination-simple
      per-page="15"
      :data="filteredCoursesList"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      @page-change="changePage"
      @sort="initSort"
      backend-sorting
      backend-pagination
      :total="totalCount"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props" slot="header">
        <b-tooltip
          type="is-info"
          position="is-left"
          v-if="props.column.field === 'new_count'"
          :label="props.column.label"
        >
          <i class="mdi mdi-briefcase-account"></i>
        </b-tooltip>
        <b-tooltip
          type="is-info"
          position="is-left"
          v-if="props.column.field === 'passed_count'"
          :label="props.column.label"
        >
          <i class="mdi mdi-briefcase-check"></i>
        </b-tooltip>
        <b-tooltip
          type="is-info"
          position="is-left"
          v-if="props.column.field === 'in_the_process_count'"
          :label="props.column.label"
        >
          <i class="mdi mdi-briefcase-edit"></i>
        </b-tooltip>
        <b-tooltip
          type="is-info"
          position="is-left"
          v-if="props.column.field === 'not_passed_count'"
          :label="props.column.label"
        >
          <i class="mdi mdi-briefcase-remove"></i>
        </b-tooltip>
        <span
          v-if="
            props.column.field != 'not_passed_count' &&
            props.column.field != 'new_count' &&
            props.column.field != 'passed_count' &&
            props.column.field != 'in_the_process_count'
          "
        >
          {{ props.column.label }}
        </span>
      </template>

      <template slot-scope="props">
        <b-table-column
          label="Название"
          :visible="true"
          field="name"
          :centered="false"
          sortable
          :width="userRole === 'admin' ? '20%' : '35%'"
        >
          <div>{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column label="Категория" :visible="true" field="categories" :centered="false" sortable width="15%">
          <div>{{ props.row.category_name }}</div>
        </b-table-column>
        <b-table-column label="Статус" :visible="true" field="status" :centered="false" sortable width="12%">
          <div>{{ props.row.status ? 'Опубликован' : 'Черновик' }}</div>
        </b-table-column>
        <b-table-column label="Длительность" :visible="true" field="days_limit" :centered="false" sortable width="13%">
          <div>{{ $counter(props.row.days_limit, [' день', ' дня', ' дней']) }}</div>
        </b-table-column>
        <b-table-column label="Всего" :visible="true" field="new_count" :centered="false" width="5%">
          <div style="padding: 15px 0; text-align: center;">{{ props.row.new_count }}</div>
        </b-table-column>
        <b-table-column label="Прошли" :visible="true" field="passed_count" :centered="false" width="5%">
          <div style="padding: 15px 0; text-align: center;">{{ props.row.passed_count }}</div>
        </b-table-column>
        <b-table-column label="В процессе" :visible="true" field="in_the_process_count" :centered="false" width="5%">
          <div style="padding: 15px 0; text-align: center;">{{ props.row.in_the_process_count }}</div>
        </b-table-column>
        <b-table-column label="Не прошли" :visible="true" field="not_passed_count" :centered="false" width="5%">
          <div style="padding: 15px 0; text-align: center;">{{ props.row.not_passed_count }}</div>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button
            class="delete_course"
            @click="deleteCourse(props.row)"
            v-if="!props.row.deleted_at"
          >
            <i class="mdi mdi-folder-remove-outline"></i> В архив
          </button>
          <button
            class="restore_course"
            @click="restoreCourse(props.row)"
            v-if="props.row.deleted_at"
          >
            <i class="mdi mdi-folder-remove-outline"></i> Восстановить
          </button>
          <button
            class="double_course"
            @click="openCoursePage(props.row)"
            v-if="!props.row.deleted_at && props.row.status"
          >
            <router-link :to="'/course-info/' + props.row.id">
              <i class="mdi mdi-file-eye-outline"></i> Страница курса
            </router-link>
          </button>
          <button class="edit_course" @click="openCourseEdit(props.row)" v-if="!props.row.deleted_at">
            <router-link :to="'/all-courses/create/' + props.row.id">
              <i class="mdi mdi-square-edit-outline"></i> Редактировать курс
            </router-link>
          </button>
          <button
            class="add_course"
            @click="openCourseStatistic(props.row)"
            v-if="!props.row.deleted_at && props.row.status"
          >
            <router-link :to="'/all-courses/course-statistic/' + props.row.id">
              <i class="mdi mdi-chart-areaspline"></i> Статистика
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    coursesList: {
      default: () => [],
      type: Array
    },
    categoriesList: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.$emit('init-sort', fieldName, sortType)
    },
    sortStatus(a, b, isAsc) {
      if (!isAsc) return a.status - b.status
      return b.status - a.status
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    openCourseEdit(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/all-courses/create/' + val.id)
      }
    },
    openCoursePage(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/course-info/' + val.id)
      }
    },
    openCourseStatistic(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/all-courses/course-statistic/' + val.id)
      }
    },
    deleteCourse(val) {
      this.$emit('delete', val)
    },
    restoreCourse(val) {
      this.$emit('restore', val)
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
  },
  computed: {
    filteredCoursesList() {
      var data = this.coursesList
      return data.filter((course) => {
        let category = this.categoriesList.find((category) => category.id === course.category_id)
        if (category) {
          course['category_name'] = category.name
          return true
        }
        if (!course.category_id) {
          course['category_name'] = '-'
          return true
        }
        return false
      })
    },
    userRole() {
      return this.$store.state.auth.role[0]
    }
  }
}
</script>
